import React, { useRef } from 'react';

import env from 'environment';

import useCollisionComponent from 'utils/useCollisionComponent';

const {
  PLATFORM_URL,
} = env;

const noop = () => {};

export const Context = React.createContext(noop);

const PinToBoardModal = ({ children }) => {
  const controlRef = useRef({ fn: noop });

  const component = useCollisionComponent({
    name: 'add_to_board',
    css: ['front/add_to_board.css'],
    props: {
      platformUrl: PLATFORM_URL,
      controlRef,
    },
  });

  return (
    <>
      {component}
      <Context.Provider value={controlRef.current}>
        { children }
      </Context.Provider>
    </>
  );
};

export default PinToBoardModal;



// WEBPACK FOOTER //
// ./app/components/PinToBoardModal.js